import { labelClassName, pxArrayToRem, pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const PageTopSectionWrapper: StyleRule = () => ({
    padding: pxArrayToRem([121, 50, 0, 50]),
});

export const PageTopSection: StyleRule = () => ({
    paddingBottom: 0,
    marginBottom: pxToRem(112),
    alignItems: 'flex-start',
});

export const TitleWrapper: StyleRule = () => ({
    position: 'relative',
    flex: 3.25,
});

export const SubCategoryTitle: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colorScheme.default?.foreground,
    fontSize: pxToRem(18),
    ...theme.siteVariables.textStyles.Text.Roman55,
});

export const CategoryDescriptionWrapper: StyleRule = ({
    theme,
    viewAllDescription,
    showCategoryTitle,
}) => ({
    flex: 1,
    paddingRight: pxToRem(72),
    marginLeft: pxToRem(showCategoryTitle ? 128 : 0),
    maxWidth: pxToRem(850),

    [`& .${labelClassName}`]: {
        color: theme.siteVariables.colorScheme.default?.foreground,
        fontSize: pxToRem(16),
        lineHeight: theme.siteVariables.lineHeightSmall,
        cursor: viewAllDescription ? 'auto' : 'pointer',
        '& p': {
            margin: 0,
        },
    },
});

export const BreadcrumbWrapper: StyleRule = () => ({
    paddingBottom: pxToRem(40),
});
